import { RefObject } from 'react';
import { create } from 'zustand';
import { SearchOption } from '../../components/Search/interfaces/search-option.enum';
import { OrderProduct } from '../../modules/orders/products/orderProducts.types';
import { IProductNotificationState, ProductActionsStore } from './productActions.types';

const useProductActionsStore = create<ProductActionsStore>((set) => ({
  orderProducts: undefined,
  productNotificationState: { productAdd: false, productAlready: false },
  deletedProductColors: [],
  addInputRef: null,
  gridInputRef: null,
  scrollToProduct: false,
  selectedOption: SearchOption.NONE,
  notificationTimerIsValid: false,

  setOrderProducts: (orderProducts: OrderProduct[]) =>
    set({ orderProducts, scrollToProduct: false }),
  setSelectedOption: (selectedOption: SearchOption) => set({ selectedOption }),
  setNotificationTimerIsValid: (flag: boolean) => set({ notificationTimerIsValid: flag }),
  setAddInputRef: (ref: RefObject<HTMLInputElement> | null) => set({ addInputRef: ref }),
  setGridInputRef: (ref: RefObject<HTMLInputElement> | null) => set({ gridInputRef: ref }),
  setScrollToProduct: (flag: boolean) => set({ scrollToProduct: flag }),
  openProductNotification: (productNotificationState: IProductNotificationState) =>
    set((state) => ({
      productNotificationState: productNotificationState.productAdd
        ? productNotificationState
        : {
            ...productNotificationState,
            isOrderProductsApplied: state.productNotificationState.isOrderProductsApplied,
          },
    })),
  closeProductNotification: () =>
    set({
      productNotificationState: {
        productAdd: false,
        productAlready: false,
        kitId: undefined,
        productColorId: undefined,
        isOrderProductsApplied: true,
      },
    }),
  setDeletedProductColors: (productColors: string[]) =>
    set({ deletedProductColors: productColors }),
  resetDeletedProductColors: () => set({ deletedProductColors: [] }),
  resetProductActionsStore: () =>
    set({
      orderProducts: undefined,
      productNotificationState: { productAdd: false, productAlready: false },
      addInputRef: null,
      gridInputRef: null,
      scrollToProduct: false,
      selectedOption: SearchOption.NONE,
      notificationTimerIsValid: false,
    }),
}));

export default useProductActionsStore;
